import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import { Logo } from "@/components/Logo";

const Section = ({ title, children }) => (
  <section className="mt-7 first:mt-0">
    <h2 className="font-display text-lg font-semibold text-slate-900">{title}</h2>
    <div className="mt-2 text-sm sm:text-base text-slate-600 leading-relaxed space-y-1">{children}</div>
  </section>
);

export default function MentionsLegales() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0B1E4D] flex flex-col" data-testid="legal-notice-page">
      <div className="gwenn-ha-du h-2.5 w-full" />
      <header className="max-w-3xl w-full mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <button onClick={() => navigate("/")} className="flex items-center" data-testid="legal-logo-home">
          <Logo flagClass="h-8" boxed />
        </button>
        <button onClick={() => navigate("/")} className="text-sm text-slate-300 hover:text-white flex items-center gap-1" data-testid="legal-back-home">
          <ArrowLeft className="h-4 w-4" /> Accueil
        </button>
      </header>

      <main className="flex-1 max-w-3xl w-full mx-auto px-5 py-8">
        <div className="bg-white rounded-2xl shadow-2xl border border-slate-200 p-6 sm:p-9">
          <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Mentions légales</h1>

          <Section title="Éditeur du site">
            <p>RenovBreizh, exploité par Mohamed Rafik, entrepreneur individuel</p>
            <p>14 boulevard de Guines, 35000 Rennes</p>
            <p>SIREN : 539 932 228</p>
            <p>Courriel : <a href="mailto:rbhabitat35@gmail.com" className="text-blue-600 hover:underline">rbhabitat35@gmail.com</a></p>
            <p>Téléphone : <a href="tel:0773211460" className="text-blue-600 hover:underline">0773211460</a></p>
          </Section>

          <Section title="Directeur de la publication">
            <p>Mohamed Rafik</p>
          </Section>

          <Section title="Hébergeur">
            <p>Emergent Labs</p>
            <p>255 California Street, Suite 550, San Francisco, CA 94111, États-Unis</p>
            <p>Contact : <a href="mailto:support@emergent.sh" className="text-blue-600 hover:underline">support@emergent.sh</a></p>
          </Section>

          <Section title="Données personnelles">
            <p>
              Les informations saisies dans le formulaire (nom, téléphone, e-mail, description et photos du projet, ville) servent
              uniquement à traiter votre demande et à la transmettre à un artisan de notre réseau. Elles sont conservées 3 ans
              maximum, puis supprimées, et ne sont pas vendues. Vous pouvez accéder à vos données, les rectifier, les effacer ou
              vous opposer à leur traitement en écrivant à{" "}
              <a href="mailto:rbhabitat35@gmail.com" className="text-blue-600 hover:underline">rbhabitat35@gmail.com</a>. Vous pouvez
              aussi saisir la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">www.cnil.fr</a>).
            </p>
          </Section>
        </div>
      </main>

      <footer className="max-w-3xl w-full mx-auto px-5 pb-8 pt-2 flex items-center justify-center">
        <button onClick={() => navigate("/")} className="text-xs text-slate-300/80 hover:text-white flex items-center gap-1.5" data-testid="legal-footer-home">
          <Home className="h-3.5 w-3.5" /> Retour à l'accueil
        </button>
      </footer>
    </div>
  );
}
